// deno-fmt-ignore-file
import { Guard } from '../../guard/index.mjs';
import { IsSchemaLike } from './schema.mjs';
// ------------------------------------------------------------------
// Guard
// ------------------------------------------------------------------
/**
 * Returns true if the schema contains a valid unevaluatedProperties property
 * @specification Json Schema 2019-09
 */
export function IsUnevaluatedProperties(schema) {
    return Guard.HasPropertyKey(schema, 'unevaluatedProperties')
        && IsSchemaLike(schema.unevaluatedProperties);
}
